
define('text!TescoMobile_Checkout/template/totals-item-promo-modal.html',[],function () { return '<div class="no-display slider-inner"><div data-role="content"> <%= data.content %> </div></div>';});

